import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { toast } from 'sonner';

export const useUpdateCustomerWithdrawal = () => {
  const { mutateAsync } = useMutation('updateCustomerWithdrawal', {
    onSuccess: (res) => {
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
